// extracted by mini-css-extract-plugin
var _1 = "Yk_m7m_xHhMOWdv9AgSM";
var _2 = "j5N8Kqvuv1FFnEIjTFRw";
var _3 = "IJU192AX63bty40jipQW";
export { _1 as "centeredMain", _2 as "intro", _3 as "title" }
